import React, { createContext, useReducer } from 'react'

import categoryReducer from './CategoryReducer'

const initialState = { categories: false, loading: true }

export const CategoryContext = createContext(initialState)

export const CategoryContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(categoryReducer, initialState)

  function getAllCategories(categories) {
    console.log(categories)
    dispatch({
      type: 'GET_ALL_CATEGORIES',
      payload: categories,
    })
  }

  function addCategory(category) {
    console.log(category);
    dispatch({
      type: 'ADD_CATEGORY',
      payload: category,
    })
  }

  function editCategory(category) {
    dispatch({
      type: 'EDIT_CATEGORY',
      payload: category,
    })
  }

  function removeCategory(id) {
    dispatch({
      type: 'REMOVE_CATEGORY',
      payload: id,
    })
  }

  return (
    <CategoryContext.Provider
      value={{
        getNewCategories: getAllCategories,
        categories: state.categories,
        addNewCategory: addCategory,
        editNewCategory: editCategory,
        deleteNewCategory: removeCategory,
      }}
    >
      {children}
    </CategoryContext.Provider>
  )
}
